define('drops/dateInput/dateInputCustom',[
    'jquery',
    'underscore',
    'require',
    'globalize',
    'lq/style',
    'lq/enum',
    'lq/constants',
    'lq/responsive',
    'lq',
    'lq/zebra/zebra_datepicker',
    'jquery.timepicker',
    'drops/modals'
], function ($, _, require, globalize, Style, Enum, constants, responsive, lq, zebraDatepicker, timepicker, modals) {
    'use strict';

    var formatTypes = new Enum("FormatType", ["Date", "Time"]);

    function DateInputCustom(drop, formatter) {
        this.drop = drop;
        this.formatter = formatter;

        this.inputFocusLostTimeout = null;

        this.$dateInput = $('<input type="text" />')
            .attr('id', drop.rootDrop.instanceId + '_' + drop.data.id)
            .addClass('date-picker')
            .css({
                width: '100%',
                height: '100%',
                display: 'inline-block'
            })
            .attr('tabindex', drop.data.tabIndex)
            .attr('placeholder', drop.data.watermark)
            .addClass('boxToBorderSize')
            .on('blur', this.onDateInputBlur.bind(this))
            .on('focus', this.cancelFocusLost.bind(this))
            .on('click', this.setCurrentDateIfNeeded.bind(this))
            .on('keyup', this.updateEmptyState.bind(this))
            .appendTo(drop.$element);

        if (drop.data.showTimePicker) {
            this.$timeInput = $('<input type="text" />')
                .css({
                    display: 'inline-block',
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '102px',
                    height: '100%'
                })
                .attr('tabindex', -1)
                .appendTo(drop.$element);
        }

        this.$dateIcon = $('<button class="Zebra_DatePicker_Icon Zebra_DatePicker_Icon_Inside">')
            .css({
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                marginRight: this.drop.data.showTimePicker ? 0 : 5,
                top: '0px',
                display: 'inline-block',
                minWidth: '20px',
                height: '100%',
                position: 'relative'
            });

        this.$timeButton = $('<span>')
            .css({
                position: 'absolute',
                border: 'none',
                padding: 0,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                marginRight: 5,
                top: '0px',
                display: 'inline-block',
                minWidth: '20px',
                height: '100%',
                position: 'relative'
            })


        if (drop.data.readOnly)
            this.$dateInput.prop('inert', true);

        this.$dateInput.css({
            border: 'none',
            font: 'inherit'
        });

        if (drop.data.fitContent) {
            this.$dateInput.css({
                fieldSizing: 'content'
            });
        }
    }

    DateInputCustom.prototype.initialize = function () {
        this.dateOnlyPhpFormat = this.filterAndConvertDateTimeFormat(this.formatter.dateFormat, formatTypes.Date);
        this.timeOnlyPhpFormat = this.filterAndConvertDateTimeFormat(this.formatter.dateFormat, formatTypes.Time);

        if (this.drop.data.precision !== 'day') {
            this.dateOnlyPhpFormat = this.dateOnlyPhpFormat
                .replace(/[jdDL]/g, '');

            if (this.drop.data.precision !== 'month') {
                this.dateOnlyPhpFormat = this.dateOnlyPhpFormat
                    .replace(/[nmMF]/g, '');
            }
        }

        if (this.drop.data.showDatePicker)
            this.attachDatePicker();

        if (this.drop.data.showTimePicker)
            this.attachTimePicker();

        if (this.drop.data.hasLightBox)
            this.createLightBoxOverlay();
    };

    DateInputCustom.prototype.cancelFocusLost = function () {
        if (this.inputFocusLostTimeout !== null)
            clearTimeout(this.inputFocusLostTimeout);
    };

    var datePatternToPhpMap = {
        yy: 'y',
        yyyy: 'Y',
        M: 'n',
        MM: 'm',
        MMM: 'M',
        MMMM: 'F',
        d: 'j',
        dd: 'd',
        ddd: 'D',
        dddd: 'L'
    };

    var timePatternToPhpMap = {
        h: 'g',
        H: 'G',
        hh: 'h',
        HH: 'H',
        mm: 'i',
        ss: 's',
        tt: 'A',
        zzz: 'P'
    };

    /*jslint regexp: true */
    DateInputCustom.prototype.filterAndConvertDateTimeFormat = function (dateTimeFormat, formatTypeToFilter) {
        var lastKnownType;
        var currentMap = formatTypeToFilter === formatTypes.Time ? timePatternToPhpMap : datePatternToPhpMap;

        return dateTimeFormat
            .replace(/(.)\1*/g, function (sameCharGroup) {
                var currentType = datePatternToPhpMap[sameCharGroup] ? formatTypes.Date :
                    timePatternToPhpMap[sameCharGroup] ? formatTypes.Time :
                        undefined;

                var result = (currentType || lastKnownType) === formatTypeToFilter ?
                    currentMap[sameCharGroup] || sameCharGroup : '';

                lastKnownType = currentType || lastKnownType;
                return result;
            });
    };
    /*jslint regexp: false */

    DateInputCustom.prototype.attachDatePicker = function () {
        var self = this;

        this.attachDateButton();

        if (this.drop.data.readOnly) {
            this.$dateInput
                .prop('readonly', true);

            this.$dateIcon
                .css({
                    cursor: 'default'
                });
        } else {
            var deviceType = responsive.getDeviceType();
            var showAtFixedLocation = deviceType === constants.deviceTypes.Phone || (deviceType === constants.deviceTypes.Tablet && window.matchMedia("(orientation: portrait)").matches);

            this.$dateInput
                .Zebra_DatePicker({
                    days: this.formatter.culture.calendar.days.names,
                    days_abbr: this.formatter.culture.calendar.days.namesAbbr,
                    months: this.formatter.culture.calendar.months.names,
                    months_abbr: this.formatter.culture.calendar.months.namesAbbr,
                    show_icon: false,
                    format: this.dateOnlyPhpFormat,
                    readonly_element: showAtFixedLocation,
                    zero_pad: false,
                    show_select_today: this.drop.data.todayLabel,
                    show_clear_date: this.drop.data.showClearButton,
                    lang_clear_date: this.drop.data.clearLabel,
                    onSelect: function (dateFormatted, dateStandard, dateObj) {
                        if (self.drop.data.precision !== 'day') {
                            var day = self.drop.data.defaultDay;
                            var month = self.drop.data.defaultMonth;

                            if (self.drop.data.defaultMonthSource === 'parameter' && self.drop.data.monthParameter) {
                                month = self.drop.piping.parameters.locals.getValue(self.drop.data.monthParameter);
                            }

                            if (self.drop.data.defaultDaySource === 'parameter' && self.drop.data.dayParameter) {
                                day = self.drop.piping.parameters.locals.getValue(self.drop.data.dayParameter);
                            } else if (self.drop.data.defaultDaySource === 'lastday') {
                                day = new Date(dateObj.getYear(), self.drop.data.precision === 'month' ? dateObj.getMonth() + 1 : month, 0).getDate();
                            }

                            if (self.drop.data.precision !== 'month') {
                                dateObj.setMonth(month - 1);
                            }
                            dateObj.setDate(day);
                        }

                        dateObj.setHours(0, 0, 0, 0);

                        var minMaxFlag = true;

                        if (dateObj && self.drop.minDateFormatted && dateObj < self.drop.minDateFormatted) {
                            minMaxFlag = false;
                            self.drop.triggerEventIfEnabled('minMaxDateNotValid');
                        }

                        if (dateObj && self.drop.maxDateFormatted && dateObj > self.drop.maxDateFormatted) {
                            minMaxFlag = false;
                            self.drop.triggerEventIfEnabled('minMaxDateNotValid');
                        }

                        if (minMaxFlag) {
                            //Stop clickthrough so Modal doesn't close when clicked on modal background
                            $('.Zebra_DatePicker').on('click', function (e) {
                                e.stopImmediatePropagation();
                            });

                            var valueChanged = self.drop.dateChanged(self.date, dateObj);

                            if (valueChanged) {
                                self.drop.date = dateObj;
                                self.dateFormatted = dateFormatted;
                                if (self.drop.data.precision !== 'day') {
                                    self.$dateInput.val(self.formatter.formatDate(dateObj));
                                }
                            }

                            self.cancelFocusLost();
                            self.drop.updateRequiredIndicator();

                            if (self.drop.data.showTimePicker)
                                self.$timeInput.timepicker('show');

                            var licquidDate = self.drop.getCurrentDateAsLicquidDate();

                            if (licquidDate) {
                                self.drop.triggerEventIfEnabled('selected', licquidDate);
                                self.drop.triggerEventIfEnabled('dateSelected', licquidDate);
                            };

                            if (valueChanged) {
                                self.drop.triggerEventIfEnabled('changed', licquidDate);
                                self.drop.triggerEventIfEnabled('dateChanged', licquidDate);
                            }
                        } else {
                            self.dateUpdated(null);
                        }
                        self.updateEmptyState();
                    },
                    onClear: function () {
                        if (self.drop.date === null)
                            return;

                        self.drop.date = null;
                        self.cancelFocusLost();
                        self.drop.updateRequiredIndicator();

                        self.drop.triggerEventIfEnabled('deselected');
                        self.drop.triggerEventIfEnabled('changed');
                        self.drop.triggerEventIfEnabled('dateChanged');
                        self.updateEmptyState();
                    },
                    onOpen: function () {
                        self.cancelFocusLost();

                        if (self.drop.data.hasLightBox) {
                            if (!self.$lightBoxOverlay) {
                                self.createLightBoxOverlay();
                            }

                            self.$lightBoxOverlay.css('display', 'block');
                        }

                        if (showAtFixedLocation) {
                            var currentDimensions = $(".Zebra_DatePicker").css(["width", "height", "margin-left"]);
                            var currentBodyHeight = $(".Zebra_DatePicker .dp_body.dp_daypicker").css("height");
                            var currentDimensionsNumbers = {
                                width: Number(currentDimensions.width.substring(0, currentDimensions.width.length - 2)),
                                height: Number(currentDimensions.height.substring(0, currentDimensions.height.length - 2)),
                                bodyHeight: Number(currentBodyHeight.substring(0, currentBodyHeight.length - 2)),
                                margin: Number(currentDimensions["margin-left"].substring(0, currentDimensions["margin-left"].length - 2)),
                            }

                            var newWidth = window.innerWidth - (2 * currentDimensionsNumbers.margin);
                            var newBodyHeight = newWidth * (currentDimensionsNumbers.bodyHeight / currentDimensionsNumbers.width);
                            var newMargin = currentDimensionsNumbers.margin == 0 ? "auto" : currentDimensionsNumbers.margin + "px";
                            if ((newBodyHeight + currentDimensionsNumbers.height - currentDimensionsNumbers.bodyHeight) > (window.innerHeight - 150)) {
                                newBodyHeight = window.innerHeight - 150 - currentDimensionsNumbers.height + currentDimensionsNumbers.bodyHeight;
                                newWidth = newBodyHeight * (currentDimensionsNumbers.width / currentDimensionsNumbers.bodyHeight);
                                newMargin = ((window.innerWidth - newWidth) / 2) + "px";
                            }

                            $(".Zebra_DatePicker").
                                css({
                                    width: newWidth + 'px !important',
                                    margin: '0 ' + newMargin + ' 0 ' + newMargin,
                                    position: 'fixed',
                                    top: 'auto',
                                    bottom: 0,
                                    zIndex: modals.getZIndexForPopups()
                                });
                            $(".Zebra_DatePicker .dp_body:not([style*=none])")
                                .css({
                                    height: newBodyHeight + 'px !important'
                                });
                            $(".Zebra_DatePicker .dp_body[style*=none]")
                                .css({
                                    height: newBodyHeight + 'px !important',
                                    display: 'none'
                                });
                        }
                        else {
                            var styleSplit = $(".Zebra_DatePicker").attr("style").split(/;/g);
                            if (styleSplit.some(function (element) { return element.includes("margin"); }) && styleSplit.some(function (element) { return element.includes("left"); }) && styleSplit.some(function (element) { return element.includes("top"); })) {
                                var left = styleSplit.find(function (element) { return element.includes("left"); });
                                var top = styleSplit.find(function (element) { return element.includes("top"); });
                                $(".Zebra_DatePicker").attr("style", left + "; " + top + ";");
                                $(".Zebra_DatePicker .dp_body:not([style*=none])").attr("style", "");
                                $(".Zebra_DatePicker .dp_body[style*=none]").attr("style", "display: none;");
                            } else {
                                var left = Number.parseFloat($(".Zebra_DatePicker:not(.dp_hidden)").
                                    css('left'));
                                $(".Zebra_DatePicker:not(.dp_hidden)").css('left', left + Math.abs(self.drop.$element.width() - self.$dateInput.width()));
                            }
                            $(".Zebra_DatePicker").
                                css('zIndex', modals.getZIndexForPopups());
                        }
                    },
                    onClose: function () {
                        if (self.$lightBoxOverlay) {
                            self.$lightBoxOverlay.css('display', 'none');
                        }
                    }
                });

            this.zebra = this.$dateInput
                .data('Zebra_DatePicker');

            if (this.drop.data.popupStyleId) {
                this.zebra.datepicker.addClass('dateinputstyle-' + this.drop.data.popupStyleId);
            } else {
                var defaultStyle = Style.getDefaultStyleIdForComponentByDropType(this.drop, 'Popup');

                if (defaultStyle)
                    this.zebra.datepicker.addClass('dateinputstyle-' + defaultStyle);
                else
                    this.zebra.datepicker.addClass('dateinputstyle-' + 'default');
            }

            this.$dateIcon
                .on('click', this.setCurrentDateAndShowDatePicker.bind(this));
        }
    };

    DateInputCustom.prototype.attachTimePicker = function () {
        var self = this;

        this.$timeInput
            .css('visibility', 'hidden');

        this.attachTimeButton();

        if (!this.drop.data.readOnly) {
            this.$timeButton
                .css({
                    cursor: 'pointer'
                })
                .on('click', function () {
                    self.$timeInput.timepicker('show');
                });

            this.$timeInput.timepicker({
                timeFormat: this.timeOnlyPhpFormat,
                step: this.drop.data.timeInputStep,
                useSelect: false,
                noneOption: false
            });

            this.$timeInput
                .on('change', function () {
                    var newTime = self.$timeInput.timepicker('getTime', self.drop.date);

                    self.dateUpdated(newTime);

                    // the time selection popup seems to be doing something really strange with the click event:
                    // triggering an event will show the ui blocker and this ui blocker will prevent
                    // the click event from propagating => the time selection popup will stay open
                    self.$timeInput.timepicker('hide');
                })
                .on('showTimepicker', function () {
                    var $popup = $(this).data("timepicker-list");
                    $popup.css('zIndex', modals.getZIndexForPopups());
                    self.cancelFocusLost();
                    var top = Number.parseFloat($popup.css('top'));
                    $popup.css('top', top + Number.parseFloat(self.drop.$element.css('border-bottom-width')));
                })
                .on('hideTimepicker', function () {
                    var licquidDate = self.drop.getCurrentDateAsLicquidDate();
                    self.$dateInput.val(self.formatter.convertFromLicquidFormat(constants.valueTypes.dateTime, licquidDate));
                });
        }
    };

    DateInputCustom.prototype.attachTimeButton = function () {
        this.$timeButton.appendTo(this.drop.$element);
        this.changeTimePickerIcon();
    };

    DateInputCustom.prototype.attachDateButton = function () {
        this.$dateIcon.appendTo(this.drop.$element);
        this.changeDatePickerIcon();
    };

    DateInputCustom.prototype.onDateInputBlur = function () {
        this.drop.updateRequiredIndicator();
        this.handleFocusLost();
    };

    DateInputCustom.prototype.handleFocusLost = function () {
        this.cancelFocusLost();

        var newDateFormatted = this.$dateInput.val();

        if (this.dateFormatted === newDateFormatted)
            return;

        var newDate = globalize.parseDate(newDateFormatted, this.formatter.dateFormat);

        // force loose date format
        if (!newDate)
            newDate = globalize.parseDate(newDateFormatted.replace(/\D/g, ''), this.formatter.looseDateFormat);

        if (this.drop.date && !this.drop.data.showDatePicker && this.drop.data.showTimePicker) {
            if (newDate) {
                newDate.setFullYear(this.drop.date.getFullYear());
                newDate.setMonth(this.drop.date.getMonth());
                newDate.setDate(this.drop.date.getDate());
            } else {
                newDate = new Date(this.drop.date);
            }
        }

        this.dateUpdated(newDate);
    };

    DateInputCustom.prototype.dateUpdated = function (newDate) {
        this.drop.updateDate(newDate);

        var self = this;
        this.inputFocusLostTimeout = setTimeout(function () {
            // we consider the input and the calendar to be a single element
            // so when the calendar is opened we have to give it some time
            // to cancel the focus lost event of the input box
            if (self.drop.isEventEnabled('focusLost')) {
                if (self.zebra.datepicker.hasClass('dp_hidden') && !$('.ui-timepicker-wrapper:visible').length && !self.$dateInput.is(':focus'))
                    self.drop.triggerEventIfEnabled('focusLost');
            }

            self.inputFocusLostTimeout = null;
        }, 100);
    };

    DateInputCustom.prototype.afterDateUpdatedSuccesfully = function (newDate) {
        this.dateFormatted = this.formatter.formatDate(newDate);
        this.$dateInput.val(this.dateFormatted);

        if (this.drop.data.showTimePicker)
            this.$timeInput.timepicker('setTime', newDate);
    };

    DateInputCustom.prototype.focus = function () {
        this.$dateInput.trigger('focus');
    };

    DateInputCustom.prototype.clearValue = function () {
        this.dateFormatted = null;

        this.$dateInput.val(null);

        if (this.drop.data.showTimePicker)
            this.$timeInput.timepicker('setTime', null);
        this.updateEmptyState();
    };

    DateInputCustom.prototype.setValue = function (newDate) {
        this.dateFormatted = this.formatter.formatDate(newDate);

        this.$dateInput.val(this.dateFormatted);

        if (this.drop.data.showTimePicker)
            this.$timeInput.timepicker('setTime', newDate);
        this.updateEmptyState();
    };

    DateInputCustom.prototype.getDatePickerImagePath = function () {
        if (this.drop.data.physicalFileDatePicker && this.drop.data.useCustomIconDatePicker)
            return lq.getTenantUploads(this.drop.data.physicalFileDatePicker);

        // non-editable property used on generated images like default preloader on list
        if (this.drop.data.cdnPath)
            return lq.getCdnUrl(this.drop.data.cdnPath);

        return null;
    };

    DateInputCustom.prototype.getTimePickerImagePath = function () {
        if (this.drop.data.physicalFileTimePicker && this.drop.data.useCustomIconTimePicker)
            return lq.getTenantUploads(this.drop.data.physicalFileTimePicker);

        // non-editable property used on generated images like default preloader on list
        if (this.drop.data.cdnPath)
            return lq.getCdnUrl(this.drop.data.cdnPath);

        return null;
    };

    DateInputCustom.prototype.changeDatePickerIcon = function () {
        var imagePath = this.getDatePickerImagePath();
        if (imagePath && this.drop.data.useCustomIconDatePicker) {
            this.setImageDatePicker(imagePath);
        } else this.setImageDatePicker(false);
    };

    DateInputCustom.prototype.changeTimePickerIcon = function () {
        var imagePath = this.getTimePickerImagePath();
        if (imagePath && this.drop.data.useCustomIconTimePicker && this.$timeButton) {
            this.setImageTimePicker(imagePath);
        } else this.setImageTimePicker(false);
    };

    DateInputCustom.prototype.setImageTimePicker = function (image) {
        if (image)
            this.$timeButton.css({
                backgroundImage: 'url(' + require.toUrl(image) + ')',
            })
        else this.$timeButton.css('background-image', '');
    };

    DateInputCustom.prototype.setImageDatePicker = function (image) {
        if (image)
            this.$dateIcon.css({
                backgroundImage: 'url(' + require.toUrl(image) + ')',
            })
        else this.$dateIcon.css('background-image', '');
    };

    DateInputCustom.prototype.setCurrentDateIfNeeded = function () {
        if (this.drop.data.dateParameterWhenOpening) {
            var licquidDateFromParameter = this.drop.piping.parameters.locals.getValue(this.drop.data.dateParameterWhenOpening);

            if (licquidDateFromParameter) {
                var dateObject = this.formatter.parseLicquidDate(licquidDateFromParameter);
                this.zebra.update({
                    current_date: dateObject
                });
            }
        }
    };

    DateInputCustom.prototype.setCurrentDateAndShowDatePicker = function () {
        this.setCurrentDateIfNeeded();

        this.zebra.show();
    };

    DateInputCustom.prototype.createLightBoxOverlay = function () {
        this.$lightBoxOverlay = $('<div />')
            .css({
                'position': 'fixed',
                'top': 0,
                'left': 0,
                'width': '100%',
                'height': '100%',
                'background-color': this.drop.data.hasLightBox ? this.drop.data.lightBoxColor : 'rgba(0, 0, 0, 0)',
                'opacity': this.drop.data.lightBoxOpacity / 100,
                'z-index': 9999,
                'display': 'none'
            });

        if (this.drop.data.toBrowser) {
            this.$lightBoxOverlay.appendTo(this.drop.piping.$actionWrapper);
        } else {
            this.$lightBoxOverlay.appendTo(this.drop.rootDrop.$element);
        }
        this.$lightBoxOverlay.appendTo(this.drop.$element);
    };

    DateInputCustom.prototype.unsubscribeEventHandlers = function () {
        var zebra = this.$dateInput.data('Zebra_DatePicker');
        if(zebra) zebra.destroy();

        // the time picker is on the time input, its list stays under the body until it's removed
        if (this.$timeInput) this.$timeInput.timepicker('remove');
    };

    DateInputCustom.prototype.updateEmptyState = function () {
        var val = this.$dateInput.val();
        if (val === undefined || val === null || val === '') {
            this.$dateInput.addClass('empty');
        } else {
            this.$dateInput.removeClass('empty');
        }
    };

    return DateInputCustom;
});

